var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99775 9.09775H9.09775V8.99775V5.09875H10.8972V8.99775V9.09775H10.9972H14.8962V10.8972H10.9972H10.8972V10.9972V14.8962H9.09775V10.9972V10.8972H8.99775H5.09875V9.09775H8.99775ZM0.1 9.9975C0.1 4.53411 4.53411 0.1 9.9975 0.1C15.4609 0.1 19.895 4.53411 19.895 9.9975C19.895 15.4609 15.4609 19.895 9.9975 19.895C4.53411 19.895 0.1 15.4609 0.1 9.9975ZM1.8995 9.9975C1.8995 14.4616 5.53337 18.0955 9.9975 18.0955C14.4616 18.0955 18.0955 14.4616 18.0955 9.9975C18.0955 5.53337 14.4616 1.8995 9.9975 1.8995C5.53337 1.8995 1.8995 5.53337 1.8995 9.9975Z",
    fill: "#F04B2F",
    stroke: "white",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.d02a5f6b9b191e248b0889956bdf6e7c.svg";
export { ForwardRef as ReactComponent };